// 需要携带communityId的路径
export const needCommunityId = [
  '/api/estate/v1/invoice/invoiceRedRecordPage',
  '/api/estate/v1/invoice/invoiceRedRecordCount',
  '/api/estate/v1/invoice/invoiceRecordPage',
  '/api/estate/v1/invoice/invoiceRecordCount',
  '/api/estate/v1/iot/accessControlFluctuantRecordCount',
  '/api/estate/v1/iot/accessControlFluctuantRecordPage',
  '/api/estate/v1/asset/parkingSpaceFluctuantRecordPage',
  '/api/estate/v1/asset/parkingSpaceFluctuantRecordCount',
  '/api/estate/v1/asset/parkingCarFluctuantRecordPage',
  '/api/estate/v1/asset/parkingCarFluctuantRecordCount',
  '/api/estate/v1/iot/accessControlConfigPage',
  '/api/estate/v1/iot/accessControlConfigCount',
  '/api/estate/v1/commerce/rentContractUnPaidPage',
  '/api/estate/v1/commerce/rentContractUnPaidCount',
  '/api/estate/v1/complain/complainReturnViewPage',
  '/api/estate/v1/complain/complainReturnViewCount',
  '/api/estate/v1/complain/complainAppraisePage',
  '/api/estate/v1/complain/complainAppraiseCount',
  '/api/estate/v1/complain/complainAssignRulePage',
  '/api/estate/v1/complain/complainAssignRuleCount',
  '/api/estate/v1/household/householdEmptyPhonePage',
  '/api/estate/v1/household/householdUnJoinCommunityPage',
  '/api/estate/v1/household/householdEmptyPhoneCountPage',
  '/api/estate/v1/household/householdStatic',
  '/api/estate/v1/commerce/rentInvestmentCluePage',
  '/api/estate/v1/commerce/rentInvestmentClueCount',
  '/api/estate/v1/commerce/rentRemindRulesPage',
  '/api/estate/v1/commerce/rentRemindRulesCount',
  '/api/estate/v1/asset/meterRecordPage',
  '/api/estate/v1/asset/meterRecordCount',
  '/api/estate/v1/share/sharePlanPage',
  '/api/estate/v1/share/sharePlanCount',
  '/api/estate/v1/asset/meterPage',
  '/api/estate/v1/asset/meterCount',
  '/api/estate/v1/finance/parkingSpaceUnPayPage',
  '/api/estate/v1/finance/parkingSpaceUnPayCount',
  '/api/estate/v1/finance/developerBalancePage',
  '/api/estate/v1/finance/buildingRoomPaymentPage',
  '/api/estate/v1/finance/buildingRoomPaymentCount',
  '/api/estate/v1/finance/parkingSpacePaymentPage',
  '/api/estate/v1/finance/parkingSpacePaymentCount',
  '/api/estate/v1/finance/ownerPreChargeAccountList',
  '/api/estate/v1/finance/ownerPreChargeAccountCount',
  '/api/estate/v1/finance/ownerPreChargeAccountList',
  '/api/estate/v1/finance/ownerPreChargeAccountCount',
  '/api/estate/v1/finance/orderPreferentialPage',
  '/api/estate/v1/finance/orderPreferentialCount',
  '/api/estate/v1/workflow/flowOrderRefundPage',
  '/api/estate/v1/workflow/flowOrderRefundCount',
  '/api/estate/v1/charge/roomDetailPage',
  '/api/estate/v1/charge/roomDetailCount',
  '/api/estate/v1/charge/moneyRulePage',
  '/api/estate/v1/charge/moneyRuleCount',
  '/api/estate/v1/oa/materialBudgetPage',
  '/api/estate/v1/oa/materialBudgetCount',
  '/api/estate/v1/workflow/refundStatistic',
  // '/api/estate/v1/worksheet/worksheetStaticByCommunity',
  // '/api/estate/v1/worksheet/worksheetStaticByCategoryPage',
  // '/api/estate/v1/worksheet/worksheetStaticByCategoryCount',
  // '/api/estate/v1/worksheet/worksheetStaticReport',
  '/api/estate/v1/commerce/rentContractInfoPage',
  '/api/estate/v1/commerce/rentContractInfoCount',
  '/api/estate/v1/commerce/rentContractTollPlanPage',
  '/api/estate/v1/commerce/rentContractTollPlanCount',
  '/api/estate/v1/finance/paymentStatistic',
  '/api/community/v1/cooperation/adminPaperPage',
  '/api/community/v1/cooperation/adminPaperCount',
  '/api/community/v1/community/investigationPaperCustomList',
  '/api/community/v1/community/conveniencePhonePage',
  '/api/community/v1/community/conveniencePhoneCount',
  '/api/community/v1/cooperation/activityContentPage',
  '/api/community/v1/cooperation/activityContentCount',
  '/api/community/v1/cooperation/helpContentPage',
  '/api/community/v1/cooperation/helpContentCount',
  '/api/community/v1/cooperation/lostContentPage',
  '/api/community/v1/cooperation/lostContentCount',
  '/api/community/v1/cooperation/leaveUnusedContentPage',
  '/api/community/v1/cooperation/leaveUnusedContentCount',
  '/api/community/v1/cooperation/voteAuditPage',
  '/api/community/v1/cooperation/voteAuditCount',
  '/api/community/v1/community/platformConveniencePhonePage',
  '/api/community/v1/community/platformConveniencePhoneCount',
  '/api/community/v1/cooperation/helpTipsPage',
  '/api/community/v1/cooperation/helpTipsCount',
  '/api/community/v1/community/recruitPage',
  '/api/community/v1/community/recruitCount',
  '/api/community/v1/community/consultPage',
  '/api/community/v1/community/consultCount',
  '/api/estate/v1/finance/paymentDetailsInfoPage',
  '/api/estate/v1/finance/paymentDetailsInfoCount',
  '/api/estate/v1/finance/paymentRecordPage',
  '/api/estate/v1/finance/paymentRecordCount',
  '/api/estate/v1/finance/paymentPage',
  '/api/estate/v1/finance/paymentCount',
  '/api/estate/v1/device/deviceMaintenancePage',
  '/api/estate/v1/device/deviceMaintenanceCount',
  '/api/estate/v1/device/deviceMaintenancePage',
  '/api/estate/v1/device/deviceMaintenanceCount',
  '/api/estate/v1/green/plantPage',
  '/api/estate/v1/green/plantCount',
  '/api/estate/v1/green/plantOnservationPlanPage',
  '/api/estate/v1/green/plantOnservationPlanCount',
  '/api/estate/v1/green/plantOnservationRecordPage',
  '/api/estate/v1/green/plantOnservationRecordCount',
  '/api/estate/v1/quality/securityServicesPage',
  '/api/estate/v1/quality/securityServicesCount',
  '/api/estate/v1/quality/cleaningServicesPage',
  '/api/estate/v1/quality/cleaningServicesCount',
  '/api/estate/v1/quality/warrantyServicesPage',
  '/api/estate/v1/quality/warrantyServicesCount',
  '/api/estate/v1/quality/greenServicesPage',
  '/api/estate/v1/quality/greenServicesCount',
  '/api/estate/v1/quality/ownerServicesPage',
  '/api/estate/v1/quality/qualityInspectionPage',
  '/api/estate/v1/quality/qualityInspectionCount',
  '/api/estate/v1/worksheet/worksheetAssignRulePage',
  '/api/estate/v1/worksheet/worksheetAssignRuleCount',
  '/api/estate/v1/worksheet/worksheetAppraisePage',
  '/api/estate/v1/worksheet/worksheetAppraiseCount',
  '/api/estate/v1/worksheet/worksheetAddressPage',
  '/api/estate/v1/worksheet/worksheetAddressCount',
  '/api/estate/v1/worksheet/worksheetReturnViewPage',
  '/api/estate/v1/worksheet/worksheetReturnViewCount',
  '/api/estate/v1/finance/chargeCriterionPage',
  '/api/estate/v1/finance/chargeCriterionCount',
  '/api/estate/v1/finance/buildingRoomUnPayPage',
  '/api/estate/v1/finance/buildingRoomUnPayCount',
  '/api/estate/v1/asset/buildingRoomCount',
  '/api/estate/v1/asset/buildingRoomPage',
  '/api/estate/v1/asset/buildingUnitPage',
  '/api/estate/v1/asset/buildingUnitCount',
  '/api/estate/v1/asset/buildingFloorPage',
  '/api/estate/v1/asset/buildingFloorCount',
  '/api/estate/v1/asset/buildingPage',
  '/api/estate/v1/asset/buildingCount',
  '/api/estate/v1/asset/buildingRoomCount',
  '/api/estate/v1/asset/buildingRoomPage',
  '/api/estate/v1/asset/parkingPage',
  '/api/estate/v1/asset/parkingCount',
  '/api/estate/v1/asset/parkingParentPage',
  '/api/estate/v1/asset/parkingParentCount',
  '/api/estate/v1/iot/parkingGateDevicePage',
  '/api/estate/v1/iot/parkingGateDeviceCount',
  '/api/estate/v1/asset/parkSpacePage',
  '/api/estate/v1/asset/parkSpaceCount',
  '/api/estate/v1/asset/parkingCarPage',
  '/api/estate/v1/asset/parkingCarCount',
  '/api/estate/v1/iot/parkingGateAccessRecordPage',
  '/api/estate/v1/iot/parkingGateAccessRecordCount',
  '/api/estate/v1/asset/parkingShareSpacePage',
  '/api/estate/v1/asset/parkingShareSpaceCount',
  '/api/estate/v1/household/householdBaseInfoPage',
  '/api/estate/v1/household/householdBaseInfoCount',
  '/api/estate/v1/patrol/patrolPlacePage',
  '/api/estate/v1/patrol/patrolPlaceCount',
  '/api/estate/v1/patrol/patrolRoutePage',
  '/api/estate/v1/patrol/patrolRouteCount',
  '/api/estate/v1/patrol/patrolRouteStatPage',
  '/api/estate/v1/patrol/patrolRouteStatCount',
  '/api/estate/v1/patrol/patrolPlaceRecordPage',
  '/api/estate/v1/patrol/patrolPlaceRecordCount',
  '/api/estate/v1/patrol/cleaningPlacePage',
  '/api/estate/v1/patrol/cleaningPlaceCount',
  '/api/estate/v1/patrol/cleaningRoutePage',
  '/api/estate/v1/patrol/cleaningRouteCount',
  '/api/estate/v1/patrol/cleaningRouteStatPage',
  '/api/estate/v1/patrol/cleaningRouteStatCount',
  '/api/estate/v1/patrol/cleaningPlaceRecordPage',
  '/api/estate/v1/patrol/cleaningPlaceRecordCount',
  '/api/estate/v1/device/devicePage',
  '/api/estate/v1/device/deviceCount',
  '/api/estate/v1/device/deviceInspectionPage',
  // '/api/estate/v1/household/visitorRulePage', // 访客规则
  // '/api/estate/v1/household/visitorRuleCount',
  '/api/estate/v1/device/deviceInspectionCount',
  '/api/estate/v1/device/deviceInspectionRecordPage',
  '/api/estate/v1/device/deviceInspectionRecordCount',
  '/api/estate/v1/renovation/renovationAgreementPage',
  '/api/estate/v1/renovation/renovationAgreementCount',
  '/api/estate/v1/workflow/flowRenovationPage',
  '/api/estate/v1/workflow/flowRenovationCount',
  '/api/estate/v1/renovation/renovationCheckRecordPage',
  '/api/estate/v1/renovation/renovationCheckRecordCount',
  '/api/estate/v1/asset/buildingRoomChangePage',
  '/api/estate/v1/asset/buildingRoomChangeCount',
  '/api/estate/v1/iot/parkingGateAccessRecordLastPage',
  '/api/estate/v1/iot/parkingGateAccessRecordLastCount',
  '/api/estate/v1/iot/parkingGateAccessRecordLastStatistic',
]

// 携带默认值的跳转路径，除specialNoOrganizationId包含的接口的页面
export const defaultValuePath = [
  '/householdManage/householdManageList',
  '/dataManage/building',
  '/dataManage/house',
  '/parkManage/parkManage',
  '/parkManage/parkPlace',
  '/parkManage/carManage',
  '/decorationManagement/decorationAgreement',
  '/decorationManagement/decorationApplication',
  '/decorationManagement/decorationPatrol',
  '/finance/paymentStandard',
  '/finance/unpaidBills',
  '/finance/paymentLog',
  '/finance/advanceOrder',
  '/finance/discount',
  '/finance/refundLog',
  '/finance/callRule',
  '/finance/collectionRecord',
  '/electronicPatrol/electronicPlace',
  '/electronicPatrol/electronicRoute',
  '/electronicPatrol/patrolStatistics',
  '/electronicPatrol/electronicLog',
  '/cleaningManagement/cleaningClock',
  '/cleaningManagement/cleaningArea',
  '/cleaningManagement/cleaningStatistics',
  '/cleaningManagement/cleaningRecords',
  '/device/deviceList',
  '/device/patrolItem',
  '/device/patrolLog',
]

export const noIntercept = [
  '/api/uc/v1/dropList/permissionCommunityDropList',
  '/api/estate/v1/finance/getCalcOrderPrice',
  '/api/estate/v1/finance/setCycleOrderPreferential',
  'api/estate/v1/finance/setOrderPreferential',
]

export const noErrMsgPopup = ['/api/estate/v1/finance/getCalcOrderPrice']

// 不需要携带organizationId的接口
export const noNeedOrganizationId = [
  '/api/estate/v1/finance/incomeRecordIns',
  '/api/estate/v1/finance/incomeRecordUpd',
  '/api/estate/v1/finance/incomeRecordPage',
  '/api/estate/v1/finance/incomeRecordDel',
  '/api/estate/v1/finance/incomeRecordCount',
  '/api/estate/v1/finance/incomeStaticByTitle',
  '/api/estate/v1/finance/incomeStaticByOrganization',
  '/api/estate/v1/dataExchange/financeIncomeExport',
]
